import React from "react";
import MyMoney from "../MyMoney/MyMoney";
import "./NavbarStyles.css";
const Navbar = () => {
  return (
    <>
      <nav className="barra">
        <ul className="navegacion">
          <li className="enlace" id="logo">
            <a href="/home" className="link">
              <MyMoney />
            </a>
          </li>
          <li className="enlace" id="cuentas">
            <a href="#cuentas" className="link">
              Cuentas
            </a>
            <div className="submenu">
              <a href="/cuentas/nueva">Registrar Cuenta</a>
              <a href="/cuentas">Listado de cuentas</a>
            </div>
          </li>
          <li className="enlace" id="etiquetas">
            <a href="#etiquetas" className="link">
              Etiquetas
            </a>
            <div className="submenu">
              <a href="/etiquetas/nueva">Registrar Etiquetas</a>
              <a href="/etiquetas">Listado de Etiquetas</a>
            </div>
          </li>
          <li className="enlace" id="gastos">
            <a href="#gastos" className="link">
              Gastos
            </a>
            <div className="submenu">
              <a href="/gastos/nuevo">Registrar Gasto</a>
              <a href="/gastos">Listado de Gastos</a>
            </div>
          </li>
          <li className="enlace" id="ingresos">
            <a href="#ingresos" className="link">
              Ingresos
            </a>
            <div className="submenu">
              <a href="/ingresos/nuevo">Registrar Ingresos</a>
              <a href="/ingresos">Listado de Ingresos</a>
            </div>
          </li>
          <li className="enlace" id="ahorro">
            <a href="#ahorro" className="link">
              Ahorro
            </a>
            <div className="submenu">
              <a href="/ahorro/meta">Registrar Meta</a>
              <a href="/ahorro/nuevo">Registrar Ahorro</a>
              <a href="/ahorro/metas">Listado de Metas</a>
            </div>
          </li>
          <li className="enlace" id="balance">
            <a href="#balance" className="link">
              Balance
            </a>
            <div className="submenu">
              <a href="/balance">Balance General</a>
              <a href="/balance/:id">Balance por cuenta</a>
            </div>
          </li>
        </ul>
      </nav>
    </>
  );
};

export default Navbar;
